(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function() {
    const section = document.querySelector('.announcement-bar');
    if (!section) return;

    const messages = section.querySelectorAll('.announcement-bar__message');
    if (messages.length <= 1) return;

    let current = 0;
    let timer;

    function show(index) {
      messages[current].classList.remove('is-active');
      current = (index + messages.length) % messages.length;
      messages[current].classList.add('is-active');
    }

    function startAutoRotate() {
      timer = setInterval(function() {
        show(current + 1);
      }, 4000);
    }

    function resetAutoRotate() {
      clearInterval(timer);
      startAutoRotate();
    }

    section.querySelector('.announcement-bar__prev').addEventListener('click', function() {
      show(current - 1);
      resetAutoRotate();
    });

    section.querySelector('.announcement-bar__next').addEventListener('click', function() {
      show(current + 1);
      resetAutoRotate();
    });

    startAutoRotate();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function() {
    function isMobile() {
      return window.innerWidth <= 768;
    }

    var toggles = document.querySelectorAll('[data-accordion-toggle]');

    toggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        if (!isMobile()) return;

        var content = toggle.nextElementSibling;
        var isActive = toggle.classList.contains('is-active');

        /* Close all others */
        toggles.forEach(function(t) {
          t.classList.remove('is-active');
          if (t.nextElementSibling) {
            t.nextElementSibling.classList.remove('is-active');
          }
        });

        if (!isActive) {
          toggle.classList.add('is-active');
          content.classList.add('is-active');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.getElementById('site-header');
    var hamburger = header.querySelector('.header__hamburger');
    var mobileMenu = document.getElementById('mobile-menu');
    var overlay = document.querySelector('.mobile-menu-overlay');
    var closeBtn = mobileMenu.querySelector('.mobile-menu__close');

    /* Sticky header */
    window.addEventListener('scroll', function() {
      if (window.scrollY > 100) {
        header.classList.add('header--sticky');
      } else {
        header.classList.remove('header--sticky');
      }
    });

    /* Mobile menu */
    function openMenu() {
      mobileMenu.classList.add('is-active');
      overlay.classList.add('is-active');
      mobileMenu.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeMenu() {
      mobileMenu.classList.remove('is-active');
      overlay.classList.remove('is-active');
      mobileMenu.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    }

    hamburger.addEventListener('click', openMenu);
    closeBtn.addEventListener('click', closeMenu);
    overlay.addEventListener('click', closeMenu);

    /* Search overlay */
    var searchToggle = document.querySelector('[data-search-toggle]');
    var searchOverlay = document.getElementById('search-overlay');
    var searchClose = document.querySelector('[data-search-close]');
    var searchInput = searchOverlay ? searchOverlay.querySelector('.search-overlay__input') : null;

    if (searchToggle && searchOverlay) {
      searchToggle.addEventListener('click', function() {
        var isActive = searchOverlay.classList.contains('is-active');
        if (isActive) {
          searchOverlay.classList.remove('is-active');
          searchOverlay.setAttribute('aria-hidden', 'true');
        } else {
          searchOverlay.classList.add('is-active');
          searchOverlay.setAttribute('aria-hidden', 'false');
          if (searchInput) searchInput.focus();
        }
      });

      if (searchClose) {
        searchClose.addEventListener('click', function() {
          searchOverlay.classList.remove('is-active');
          searchOverlay.setAttribute('aria-hidden', 'true');
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var slideshow = document.querySelector('.hero-slideshow');
    if (!slideshow) return;

    var slides = slideshow.querySelectorAll('.hero-slideshow__slide');
    var dots = slideshow.querySelectorAll('.hero-slideshow__dot');
    if (slides.length <= 1) return;

    var current = 0;
    var speed = (parseInt(slideshow.dataset.autoplaySpeed) || 5) * 1000;
    var timer;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      dots[current].classList.add('is-active');
    }

    function startAutoplay() {
      timer = setInterval(function() {
        goTo(current + 1);
      }, speed);
    }

    function stopAutoplay() {
      clearInterval(timer);
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goTo(parseInt(dot.dataset.slideIndex));
        stopAutoplay();
        startAutoplay();
      });
    });

    slideshow.addEventListener('mouseenter', stopAutoplay);
    slideshow.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function() {
    var qtyBtns = document.querySelectorAll('.cart-page__qty-btn');

    qtyBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.parentElement.querySelector('.cart-page__qty-input');
        var currentVal = parseInt(input.value) || 1;

        if (btn.dataset.action === 'increase') {
          input.value = currentVal + 1;
        } else if (btn.dataset.action === 'decrease' && currentVal > 0) {
          input.value = currentVal - 1;
        }

        /* Auto-submit form on quantity change */
        input.closest('form').submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function() {
    var sortSelect = document.getElementById('sort-by');
    if (!sortSelect) return;

    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var questions = document.querySelectorAll('.faq-page__question');

    questions.forEach(function(question) {
      question.addEventListener('click', function() {
        var answer = question.nextElementSibling;
        var isActive = question.classList.contains('is-active');

        /* Close all others */
        questions.forEach(function(q) {
          q.classList.remove('is-active');
          q.setAttribute('aria-expanded', 'false');
          q.nextElementSibling.classList.remove('is-active');
        });

        if (!isActive) {
          question.classList.add('is-active');
          question.setAttribute('aria-expanded', 'true');
          answer.classList.add('is-active');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var section = document.querySelector('.product');
    if (!section) return;

    /* Thumbnail gallery */
    var mainImages = section.querySelectorAll('.product__main-image');
    var thumbnails = section.querySelectorAll('.product__thumbnail');

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var index = parseInt(thumb.dataset.thumbnailIndex);
        thumbnails.forEach(function(t) { t.classList.remove('is-active'); });
        mainImages.forEach(function(img) { img.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        mainImages[index].classList.add('is-active');
      });
    });

    /* Variant selector with JSON data */
    var variants = [];
    try {
      var jsonEl = document.getElementById('product-variants-json');
      if (jsonEl) variants = JSON.parse(jsonEl.textContent);
    } catch(e) {}

    var optionBtns = section.querySelectorAll('.product__option-btn');
    var variantInput = section.querySelector('#product-variant-id');
    var addToCartBtn = section.querySelector('.product__add-to-cart');
    var priceEl = section.querySelector('.product__price');

    optionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.classList.contains('is-unavailable')) return;

        var position = btn.dataset.optionPosition;
        var siblings = section.querySelectorAll('[data-option-position="' + position + '"]');
        siblings.forEach(function(s) { s.classList.remove('is-selected'); });
        btn.classList.add('is-selected');

        /* Build selected options */
        var selectedOptions = [];
        section.querySelectorAll('.product__option').forEach(function(group) {
          var selected = group.querySelector('.product__option-btn.is-selected');
          if (selected) selectedOptions.push(selected.dataset.optionValue);
        });

        /* Find matching variant */
        var matched = variants.find(function(v) {
          return v.options.every(function(opt, i) {
            return !selectedOptions[i] || opt === selectedOptions[i];
          });
        });

        if (matched && variantInput) {
          variantInput.value = matched.id;
          /* Update price display */
          var cents = matched.price;
          var priceStr = (cents / 100).toFixed(2).replace('.', ',');
          if (priceEl) {
            priceEl.innerHTML = '<span>&euro;' + priceStr + '</span>';
          }
          /* Update URL */
          var url = new URL(window.location.href);
          url.searchParams.set('variant', matched.id);
          window.history.replaceState({}, '', url.toString());
          /* Update button state */
          if (addToCartBtn) {
            if (matched.available) {
              addToCartBtn.disabled = false;
              addToCartBtn.textContent = 'IN WINKELMAND';
            } else {
              addToCartBtn.disabled = true;
              addToCartBtn.textContent = 'UITVERKOCHT';
            }
          }
        }
      });
    });

    /* Image zoom on hover (desktop only) */
    var imageWrap = section.querySelector('.product__main-image-wrap');
    if (imageWrap && !('ontouchstart' in window)) {
      imageWrap.classList.add('zoom-active');

      imageWrap.addEventListener('mousemove', function(e) {
        var activeImg = imageWrap.querySelector('.product__main-image.is-active');
        if (!activeImg) return;
        var rect = imageWrap.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        activeImg.style.transformOrigin = x + '% ' + y + '%';
        activeImg.style.transform = 'scale(1.5)';
      });

      imageWrap.addEventListener('mouseleave', function() {
        var activeImg = imageWrap.querySelector('.product__main-image.is-active');
        if (activeImg) {
          activeImg.style.transform = 'scale(1)';
          activeImg.style.transition = 'transform 0.3s ease';
          setTimeout(function() { activeImg.style.transition = ''; }, 300);
        }
      });
    }

    /* Collapsible toggles */
    var toggles = section.querySelectorAll('.product__collapsible-toggle');
    toggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var content = toggle.nextElementSibling;
        var isActive = toggle.classList.contains('is-active');
        toggle.classList.toggle('is-active');
        content.classList.toggle('is-active');
        toggle.setAttribute('aria-expanded', !isActive);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
